/** Created by azhou on 2019/2/26.*/
<template>
    <div>
      <public-title showBack>设置代订收款</public-title>
      <!-- <public-title :showBack="isAdmin || Boolean(queryCon.GST)">设置</public-title> -->
      <div class="load-area">
        <div v-if="isGroup && !Boolean(queryCon.GST)">
          <group-store-lists />
        </div>
        <div v-else>
          <el-tabs v-model="activeTab" type="card" v-show="!isAdmin">
            <el-tab-pane :label="item" :name="item" v-for="item in tabArr" :key="item" v-if="item==activeTab"/>
          </el-tabs>
          <post-room-order v-if ="activeTab === '住宿订单'"/>
          <MeetingRequirements v-if ="activeTab === '纯会议订单(不住宿)'"/>
          <!-- <yearcard-order v-show ="activeTab === '预订年卡'"/> -->
          <list-wrap v-if="activeTab === '预订民宿' || activeTab === '景区门票'" />
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PostRoomOrder from './NewRoomMeetOrder'
  import MeetingRequirements from './MeetingRequirements'
  export default {
    name: 'limitation',
    components: { PostRoomOrder,MeetingRequirements},
    computed: {
      ...mapGetters(['storeInfo','isAdmin','isGroup']),
      queryType() { return this.$route.query.type },
      queryCon() { return this.$route.query },
      //是否是代订收款修改
      invoicing_change() { return this.$route.query.invoicing_change},
      /**
       * @return {string}
       */
      TipText() {
        console.log();
        switch (this.storeInfo.type) {
          case 2:
            if (this.isGroup && !Boolean(this.queryCon.GST)) return '请选择要发布订单的门店';
            else return this.$route.query.modify?'修改订单':'发布订单'
            break
          case 99:return '重新编辑订单';
          default:return '';
        }
      }
    },
    data() {
      return {
        // tabArr:['住宿订单','预订民宿','景区门票'],
        tabArr:['住宿订单','纯会议订单(不住宿)'],
        activeTab:'住宿订单'
      }
    },
    created() { this.activeTab = this.queryType },
    watch: {
      activeTab(newVal) {
        this.$router.replace({name:this.$route.name,query:{...this.queryCon,type:newVal}})
      }
    }
  }
</script>
